export default {
      id: "logs-usage",
      viewBox: "0 0 29.5 25.958",
      url: __webpack_public_path__ + "img/icons.8ad0c046.svg#logs",
      toString: function () {
        return this.url;
      }
    }